module.exports = __webpack_public_path__ + "img/ss_blue-04.164da0da.jpg";